import { useEffect } from 'react'

import { useMemoizedFn } from 'ahooks'
import { EditorState, Klass, LexicalNode, NodeMutation } from 'lexical'

import { useEditor } from '../useEditor'

export const useMutationListener = (
  nodeType: Klass<LexicalNode>,
  mutationType: NodeMutation,
  listener: (
    nodeKey: string,
    payload: {
      updateTags: Set<string>
      dirtyLeaves: Set<string>
      prevEditorState: EditorState
    }
  ) => false | undefined | null | void
) => {
  const editor = useEditor()

  const memoizedListener = useMemoizedFn(listener)

  useEffect(() => {
    return editor.registerMutationListener(
      nodeType,
      (mutatedNodes, payload) => {
        for (const [nodeKey, mutation] of mutatedNodes) {
          if (mutation === mutationType) {
            const flag = memoizedListener(nodeKey, payload)
            if (flag === false) {
              break
            }
          }
        }
      }
    )
  }, [editor, mutationType, nodeType, memoizedListener])
}
